<template>
    <CCard class="order-fd-card">
        <CCardHeader>
            <strong>Доставка цветов</strong> <small>Подробности заказа</small>
        </CCardHeader>
        <CCardBody>
            <CTabs variant="tabs" :active-tab="0">
                <CTab title="Карточка" class="pt-1">
                    <CDataTable
                        hover
                        :items="orderUnmodified.items"
                        :fields="fields">
                        <template #florist="data">
                            <td>
                                {{ data.item.florist.title }}
                            </td>
                        </template>

                        <template #bouquet="data">
                            <td>
                                {{ data.item.bouquet.title }}
                            </td>
                        </template>

                        <template #price="data">
                            <td>
                                {{ data.item.bouquet.price }}
                            </td>
                        </template>

                        <template #options="data">
                            <td>
                                <span v-for="opt in data.item.options" :key="opt.title">
                                    {{ opt.title }} - {{ opt.price }} р.<br />
                                </span>
                            </td>
                        </template>

                        <template #extras="data">
                            <td>
                                <span v-for="ext in data.item.extras" :key="ext.title">
                                    {{ ext.title }} - {{ ext.price }} р.<br />
                                </span>
                            </td>
                        </template>

                        <template #refund_for="data">
                            <td>
                                {{ 
                                    data.item && data.item.refund_for && data.item.refund_comment
                                        ? ` За счет ${data.item.refund_for} (${data.item.refund_comment}) - ${data.item.refund_sum}р.`
                                        : ''
                                }}
                            </td>
                        </template>

                        <template #edit> </template>
                    </CDataTable>
                </CTab>
            </CTabs>
        </CCardBody>

        <OrderFDItemEdit
            :modal="itemEditModal"
            @update="itemUpdate"
            @cancel="itemCancel"
        />
    </CCard>
</template>

<script>
    const { formatDate } = require('../../utils/views');
    import OrderFDItemEdit from './OrderFDItemEdit';

    export default {
        name: 'OrderFD',

        components: {
            OrderFDItemEdit,
        },

        props: {
            order: {
                type: Object,
                default: () => ({}),
            },
            orderUnmodified: {
                type: Object,
                default: () => ({}),
            },
        },

        data() {
            return {
                isAuthorized: false,
                fields: [
                    {
                        key: 'florist',
                        label: 'Флорист',
                        _classes: 'font-weight-bold',
                    },
                    { key: 'bouquet', label: 'Букет' },
                    { key: 'quantity', label: 'Кол-во' },
                    { key: 'price', label: 'Цена' },
                    { key: 'options', label: 'Виды' },
                    { key: 'extras', label: 'Дополнительно' },
                    { key: 'refund_for', label: 'Возврат' },
                    { key: 'amount', label: 'Цена итоговая' },
                    { key: 'edit', label: '' },
                ],
                itemEditModal: {
                    item: {},
                    visible: false,
                    emptyItem: {
                        florist: {},
                        bouquet: {},
                        options: [],
                        extras: [],
                        refund_for: '',
                        refund_comment: '',
                        price: 0,
                        quantity: 1,
                    },
                },
            };
        },

        computed: {},

        methods: {
            formatDate(date) {
                return formatDate(date);
            },
            itemAdd() {
                this.itemEditModal.item = JSON.parse(JSON.stringify(this.itemEditModal.emptyItem));
                this.itemEditModal.visible = true;
            },
            itemEdit(id) {
                for (let i = 0; i < this.order.items.length; i++) {
                    if (this.order.items[i].id === id) {
                        this.itemEditModal.item = JSON.parse(JSON.stringify(this.order.items[i]));
                        this.itemEditModal.visible = true;
                    }
                }
            },
            itemDelete(id) {
                for (let i = 0; i < this.order.items.length; i++) {
                    if (this.order.items[i].id === id) {
                        this.order.items.splice(i, 1);
                    }
                }
            },
            itemUpdate() {
                let items = [];
                for (let i = 0; i < this.order.items.length; i++) {
                    if (this.order.items[i].id === this.itemEditModal.item.id) {
                        items.push(this.itemEditModal.item);
                    } else {
                        items.push(this.order.items[i]);
                    }
                }
                if (!this.itemEditModal.item.id) {
                    this.itemEditModal.item.id = 'temp-' + this.order.items.length;
                    items.push(JSON.parse(JSON.stringify(this.itemEditModal.item)));
                }
                this.order.items = items;
                this.itemCancel();
            },
            itemCancel() {
                this.itemEditModal.item = this.itemEditModal.emptyItem;
                this.itemEditModal.visible = false;
            },
            orderUpdate() {
                for (let i = 0; i < this.order.items.length; i++) {
                    if (this.order.items[i].id && this.order.items[i].id.toString().indexOf('temp-') >= 0) {
                        delete this.order.items[i].id;
                    }
                }
                this.$emit('update');
            },
        },
    };
</script>

<style>
.order-fd-card .table th,
.order-fd-card .table td {
    vertical-align: middle;
}
</style>
